<template>
  <div class="my-layout-box p-order-23892k">
    <list-view :getList="getList" :isTabsShow="isTabsShow" :isButtonShow="isButtonShow" :isSearchShow="isSearchShow"
      :listMap="listMap" :placeholderTitle="placeholderTitle" :tabList="tabList" :buttonList="buttonList"
      @changeTab="changeTab" @onSeeDetail="onSeeDetail" @onEdit="onEdit">
    </list-view>
  </div>
</template>

<script>
import listView from "~/components/List/ListView.vue";
import { orderData, HKOrderData, HKStockData, OcrList } from "./config";
import { getOrder, getHKOrder, getHKStock } from "~/api/order";
import OCROrderApi from "@/api/ocr-order-api";
import { Dialog, Toast } from "vant";

export default {
  name: "orderListView",
  components: {
    listView
  },
  data() {
    return {
      isTabsShow: true,
      isButtonShow: true,
      isSearchShow: true,
      listMap: orderData,
      placeholderTitle: "请输入单号",
      tabList: [{ title: "进口单" }, { title: "本港单" }, { title: "本港出库单" }
        //  , { title: "OCR理货", onCreate: this.ocrCreate }
      ],
      tabType: 0,
      buttonList: [{ title: "查看详情" }]
    };
  },

  methods: {
    aCreate() {

      Dialog.confirm({
        message:
          "建议您在电脑上操作以获得更好体验。\n电脑端网址：znlscm.com 。\n如有疑问请致电：0755-82798001，谢谢~",
        confirmButtonText: "复制网址"
      }).then(e => {
        navigator.clipboard.writeText("https://znlscm.com/").then(() => {
          Toast.success("网址已经复制");
        }); ``
      });
      this.$router.push({
        name: "OrderEdit",
        query: {

        }
      });
    },
    ocrCreate() {
      this.$router.push({
        name: "ocr-order-editor",
        query: {}
      });
    },
    async getList(pagination, searchData) {
      const { tabType } = this;
      let sendData = {
        page: pagination.page,
        limit: pagination.size
      };

      let list = null;
      if (tabType == 0) {
        this.listMap = orderData;
        sendData.Code = searchData.value;
        this.buttonList = [{ title: "查看详情" }, { title: "编辑" }]
        list = await getOrder(sendData);
      } else if (tabType == 1) {
        sendData.OrderNo = searchData.value || "";
        this.listMap = HKOrderData;
        list = await getHKOrder(sendData);
        this.buttonList = [{ title: "查看详情" }]
      } else if (tabType == 2) {
        sendData.AgentOrderNo = searchData.value || "";
        this.listMap = HKStockData;
        list = await getHKStock(sendData);
        this.buttonList = [{ title: "查看详情" }]
      }
      else if (tabType == 3) {
        sendData.Code = searchData.value || "";
        this.listMap = OcrList;
        list = await OCROrderApi.takeList(sendData);
        this.buttonList = [{ title: "查看详情" }]
      }
      const data = {
        List: list.Items,
        Total: list.Total
      };
      return data;
    },
    changeTab(type) {
      this.tabType = type;
    },
    onSeeDetail(items) {
      console.log(items);
      const { Id } = items;
      const { tabType } = this;
      const routeMap = {
        0: "orderDetail",
        1: "hkOrderDetail",
        2: "hkStockDetail",
        3: "ocr-order-detail"
      };
      const routeName = routeMap[tabType];
      this.$router.push({
        name: routeName,
        query: {
          id: Id
        }
      });
    },

    onEdit(id) {
      this.$router.push({
        name: 'OrderEdit',
        query: {
          id: id
        }
      });
    }
  }
};
</script>

<style lang="less">
.p-order-23892k {
  .system-order::after {
    content: "系统";
    margin-left: 0.5em;
    background-color: #ff976a;
    color: #fff;
    padding: 0 0.5em;
    border-radius: 99px;
  }
}
</style>
